import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Navbar, Footer } from '@/components/Layout';
import { BindingLegalList } from '@/components/legal/BindingLegalList';
import { GateLegalStatusNote } from '@/components/binding/GateProposedNotice';
import { BAG_TERMS, BAG_PRIVACY, BAG_LEGAL_EFFECTIVE } from '@/components/legal/bindingGateLegal';

const KINDS = {
  terms: { title: 'Binding Action Gate Terms', items: BAG_TERMS, full: ['/terms#binding-gate', 'Full Terms of Service'], other: ['/binding-gate/privacy', 'Gate Privacy Notice'] },
  privacy: { title: 'Binding Action Gate Privacy Notice', items: BAG_PRIVACY, full: ['/privacy#public-ledger', 'Full Privacy Policy'], other: ['/binding-gate/terms', 'Gate Terms'] },
};

export default function BindingGateLegal({ kind }) {
  const k = KINDS[kind];
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid={`binding-gate-${kind}-page`}>
      <Helmet><title>{`${k.title} | Kojiru`}</title></Helmet>
      <Navbar />
      <main className="container mx-auto max-w-3xl px-6 pt-32 pb-20">
        <Link to="/binding-gate" className="text-xs text-red-300 hover:text-red-200" data-testid="binding-legal-back">Back to the Binding Action Gate (proposed design)</Link>
        <h1 className="text-4xl sm:text-5xl font-bold mt-4 mb-2" data-testid="binding-legal-title">{k.title}</h1>
        <p className="text-sm text-gray-500 mb-6">Effective {BAG_LEGAL_EFFECTIVE}</p>
        <GateLegalStatusNote testid={`binding-${kind}-status-note`} />
        <BindingLegalList items={k.items} testid={`binding-${kind}-list`} />
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-wrap gap-6 text-sm">
          <Link to={k.full[0]} className="text-gray-300 underline hover:text-white" data-testid="binding-legal-full-link">{k.full[1]}</Link>
          <Link to={k.other[0]} className="text-gray-300 underline hover:text-white" data-testid="binding-legal-other-link">{k.other[1]}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
